export const __freePriceFilterWrapper = ({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	paddingTop: theme.spaces[16],
	paddingBottom: theme.spaces[16],
	borderBottom: `1px solid ${theme.colors.shimmerGrey}`,
})

export const __wrapper = ({ theme }) => ({
	width: '100%',
	marginBottom: theme.spaces[16],
})
